'use client'

import {Heart, User} from 'lucide-react'
import React from 'react'

import {Routes} from '@/src/config/routes'

import {BasketProvider} from '@/src/entities/basket/ui/provider'
import {FavouriteProvider} from '@/src/features/favourite'

import shoePic from '@/src/shared/assets/media/icon-shoe.svg'
import logoDarkPic from '@/src/shared/assets/media/logo-dark.svg'
import IconBasket from '@/src/shared/ui/icons/basket'
import {Image} from '@/src/shared/ui/image'
import {BasketCountContainer} from '@/src/shared/ui/layout/ui/header/basket-count'

import {BackTop} from './back-top'
import {Footer} from './footer'
import {Header} from './header/header'
import * as UI from './layout.styled'
import {RunlabLayoutProvider} from './provider'
import {useRouter} from 'nextjs-toploader/app'
import {FavouriteCountContainer} from './header/favourite-count'

const showBackButton = process.env.NEXT_PUBLIC_APP_ENV !== 'test'

export const RunlabLayout = ({children, data}: {data: LayoutData} & React.PropsWithChildren) => {
  return (
    <RunlabLayoutProvider data={data}>
      <FavouriteProvider>
        <BasketProvider>
          <RunlabLayoutContent>{children}</RunlabLayoutContent>
        </BasketProvider>
      </FavouriteProvider>
    </RunlabLayoutProvider>
  )
}

const RunlabLayoutContent = ({children}: React.PropsWithChildren) => {
  const router = useRouter()

  return (
    <UI.Wrapper>
      <Header />
      {children}
      <UI.MobileBottomMenu data-mobile-menu>
        <UI.MobileBottomContainer>
          <UI.MobileBottomButton onClick={() => router.push(Routes.catalog.page)}>
            <Image src={logoDarkPic} sizes="100vw" width={0} height={0} alt="Каталог" />
            <span>Каталог</span>
          </UI.MobileBottomButton>
          <UI.MobileBottomButton onClick={() => router.push(Routes.profile.page)}>
            <User />
            <span>Профиль</span>
          </UI.MobileBottomButton>

          <UI.MobileBottomButton onClick={() => router.push(Routes.favourite.page)}>
            <Heart />
            <span>Избранное</span>

            <UI.FavouriteCount as={FavouriteCountContainer} />
          </UI.MobileBottomButton>

          <UI.MobileBottomButton onClick={() => router.push(Routes.basket.page)}>
            <UI.IconBasket as={IconBasket} />
            <span>Корзина</span>

            <UI.BasketCount as={BasketCountContainer} />
          </UI.MobileBottomButton>

          <UI.MobileBottomButton onClick={() => router.push(Routes.service.shoeTesting)}>
            <Image
              src={shoePic}
              sizes="100vw"
              width={0}
              height={0}
              alt="Записаться на подбор обуви"
            />
            <span>Подбор</span>
          </UI.MobileBottomButton>
        </UI.MobileBottomContainer>
      </UI.MobileBottomMenu>
      <Footer />

      {showBackButton && <BackTop />}
    </UI.Wrapper>
  )
}
